require('./geoZoneMap.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const d3 = require('d3');
const topojson = require('topojson');
const millerProjection = require('d3-geo-projection').geoMiller;

// @local
const world = require('./world-map.json');
const {continents} = require('./geoZoneMapHelpers');

const blackBox = props => {

    const { activeRegion, width, height, handleActiveRegionChange } = props;

    return me => {
        const mapG = me.select('.geozone-map__g');
        const tooltip = me.select('.geozone-map__tooltip');

        mapG.selectAll("path").remove();

        const scale = (width - 3) / (2 * Math.PI);
        const translation = [width / 2 - 10, height / 2 + 20];

        const projection = millerProjection()
            .scale(scale)
            .translate(translation);

        const path = d3.geo.path().projection(projection);

        const countries = topojson.feature(world, world.objects.countries);
        const continentsArray = continents(countries);
        const continent = mapG.selectAll('path').data(continentsArray);
        continent.exit().remove();
        continent.enter().append('path')
            .attr('class', d => d.id === activeRegion ?
                'geozone-map__continent--active' : 'geozone-map__continent')
            .attr('d', path)
            .attr('id', d => d.id )
            .attr('title', d => d.name )
            .on('mouseenter', d => {
                handleActiveRegionChange(d.id);
                tooltip
                    .classed('hidden', false)
                    .html(d.name);
            })
            .on('mousemove', () => tooltip
                .style('left', d3.mouse(me.node())[0] + 'px')
                .style('top', d3.mouse(me.node())[1] + 'px'))
            .on('mouseleave', () => tooltip.classed('hidden', true));
    }
};

class GeoZoneMap extends React.Component {

    constructor(props) {
        super(props);
        this.setNode = this.setNode.bind(this);
    }

    componentDidMount() {
        d3.select(this.nodeReference)
            .call(blackBox(this.props));
    }

    componentDidUpdate(prev) {
        if (prev.activeRegion !== this.props.activeRegion) {
            d3.select(this.nodeReference)
                .call(blackBox(this.props));
        }
    }

    setNode(ref) {
        this.nodeReference = ref;
    }

    render() {
        return (
            <div ref={this.setNode} className="geozone-map">
                <svg
                    width={this.props.width}
                    height={this.props.height}
                    shapeRendering="geometricPrecision"
                >
                    <g className="geozone-map__g"></g>
                </svg>
                <div className="geozone-map__tooltip hidden"></div>
            </div>
        );
    }
}

GeoZoneMap.propTypes = {
    activeRegion: PropTypes.number.isRequired,
    handleActiveRegionChange: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
};

module.exports = GeoZoneMap;